import React, { PropTypes } from 'react';
import { CargoType } from 'types';
import ActionCreators from 'actions/ActionCreators';
import { CategoryType } from 'types';
import classnames from 'classnames';
import ga from 'react-ga';
import { getCargoNames } from 'api';
import CargosStore from 'stores/CargosStore';
import CargosConstants from 'constants/Cargos';
import SubcategoriesConstants from 'constants/Subcategories';

import './Subcategory.scss';

/**
 * Элемент подкатегории. Кнопка выбора типа груза.
 */
class Subcategory extends React.Component {

    static propTypes = {
        cargo: PropTypes.instanceOf(CargoType).isRequired,
        onCargoFinish: PropTypes.func,
        selectedCategory: PropTypes.instanceOf(CategoryType),
    }

    static defaultProps = {
        selected: false
    }

    _getBookSeparateCarVolumeM3andWeightKG = () => {
        var volume = 0;
        var weight = 0;

        switch (this.props.cargo.stuff_type_id) {
            case SubcategoriesConstants.KABLUK:
                volume = 3;
                weight = 650;
                break;
            case SubcategoriesConstants.PORTER_SOBOL:
                volume = 6;
                weight = 1000;
                break;
            case SubcategoriesConstants.GAZEL:
                volume = 12;
                weight = 1500;
                break;
            case SubcategoriesConstants.BICHOK:
                volume = 25;
                weight = 3000;
                break;
            case SubcategoriesConstants.FIVE_TONS_CAR:
                volume = 30;
                weight = 5000;
                break;
            case SubcategoriesConstants.TEN_TONS_CAR:
                volume = 50;
                weight = 10000;
                break;
            case SubcategoriesConstants.TWENTY_TONS_CAR:
                volume = 86;
                weight = 20000;
                break;
        }

        return {
            volume: volume,
            weight: weight,
        };
    }

    _onClick = () => {
        ga.event({
            category: 'buttons',
            action: `click_button_${this.props.cargo.name}_booking_step_2`,
            label: this.props.selectedCategory.name,
            value: 1,
        });

        switch (this.props.selectedCategory.name) {
            case 'book_separate_car':

                ActionCreators.showLoadingOverlay();

                getCargoNames(this.props.cargo.get('name'), true).then((data) => {
                    ActionCreators.hideLoadingOverlay();

                    const volume = this._getBookSeparateCarVolumeM3andWeightKG().volume;
                    const weight = this._getBookSeparateCarVolumeM3andWeightKG().weight;

                    if (data.response && !data.response[0]) {
                        ActionCreators.generateCargo(this.props.cargo, {
                            name: `${this.props.cargo.get('name')}`,
                        }, true);
                    } else {
                        let cargo = data.response[0];
                        let attributes = {};

                        for (let key in cargo.attributes) {
                            let attribute = cargo.attributes[key];
                            attributes[attribute.id] = attribute.value;
                        }

                        attributes[CargosConstants.ATTRIBUTE_NAME] = this.props.cargo.get('name');

                        if (volume > 0) {
                            attributes[CargosConstants.ATTRIBUTE_VOLUME] = volume;
                        }

                        cargo.attributes = attributes;

                        CargosStore.clearDeliveryCargos();
                        CargosStore.denormalizeCargo(cargo);
                    }

                    ActionCreators.setTotalMeasurements(weight, volume, true);
                });

                break;
            default:
                ActionCreators.addCargo(this.props.cargo);
                break;
        }
    }

    render() {

        var subcategoryClasses = classnames({
            'Subcategory': true,
            'Subcategory--selected': this.props.selected
        });

        return (
            <div className={subcategoryClasses}
                onClick={this._onClick}
                id={"subcategory_" + this.props.cargo.stuff_type_id}>
                {this.props.cargo.name}
            </div>
        );
    }

}

export default Subcategory;



// WEBPACK FOOTER //
// ./client/components/Subcategory/Subcategory.js